export const categories = [
  {
    slug: 'zuixin-dizhi',
    name: '最新地址',
    icon: 'ri-link',
    description: '实时更新草榴社区最新可用访问地址与备用域名',
  },
  {
    slug: 'fangwen-jiaocheng',
    name: '访问教程',
    icon: 'ri-guide-line',
    description: '详细的访问教程，涵盖PC端与移动端操作指南',
  },
  {
    slug: 'changjian-wenti',
    name: '常见问题',
    icon: 'ri-question-answer-line',
    description: '汇总用户常见问题，提供快速解决方案',
  },
  {
    slug: 'shiyong-jiqiao',
    name: '使用技巧',
    icon: 'ri-lightbulb-line',
    description: '分享社区使用小技巧，提升浏览体验',
  },
  {
    slug: 'shequ-dongtai',
    name: '社区动态',
    icon: 'ri-newspaper-line',
    description: '关注草榴社区最新动态与重要公告',
  },
];

export const articles = [
  {
    slug: 'caoliu-2026-zuixin-dizhi-gonggao',
    title: '草榴社区2026年8月最新可用地址公告',
    excerpt: '本文汇总了2026年8月草榴社区最新可用地址及备用域名入口，确保您能够顺利访问社区。',
    content: `
      <p>随着网络环境的变化，草榴社区会不定期更新访问地址，以确保广大用户能够持续稳定地访问社区内容。以下是2026年8月经测试确认可用的最新地址汇总。</p>
      <h2>最新主域名</h2>
      <p>当前草榴社区主域名已更新，请用户及时收藏新地址。我们建议同时保存多个备用域名，以防主域名因网络波动暂时无法访问。</p>
      <p>访问时请注意核对网址拼写，避免进入仿冒网站。官方地址均以标准格式呈现，任何要求输入个人信息或下载不明文件的网站均为仿冒。</p>
      <h2>备用域名入口</h2>
      <p>我们提供多个备用域名入口，在主域名不可用时可以自动切换。建议将本导航页添加至浏览器书签，随时获取最新地址信息。</p>
      <h2>安全访问建议</h2>
      <p>为保障账号安全与浏览体验，建议使用Chrome或Firefox浏览器访问，并确保浏览器已更新至最新版本。访问前请清除DNS缓存以获得最佳连接效果。</p>
    `,
    category: 'zuixin-dizhi',
    categoryName: '最新地址',
    date: '2026-08-06',
    readTime: 3,
  },
  {
    slug: 'caoliu-beiyong-yuming-shouce',
    title: '草榴备用域名使用手册：如何快速切换入口',
    excerpt: '详细介绍草榴社区备用域名的使用方法和切换技巧，确保任何时候都能找到回家的路。',
    content: `
      <p>备用域名是草榴社区为保障用户访问稳定性而提供的重要功能。当主域名因各种原因无法访问时，备用域名可以帮助您快速恢复连接。</p>
      <h2>什么是备用域名</h2>
      <p>备用域名是草榴社区预先注册的多个域名地址，它们指向同一个社区服务器。当某个域名受到限制时，其他域名仍可正常使用。</p>
      <h2>如何使用备用域名</h2>
      <p>使用备用域名非常简单，只需将原有主域名替换为备用域名即可，网站内容和功能完全一致。建议将本导航页面加入收藏夹，可以随时查看最新的可用域名列表。</p>
      <h2>域名切换注意事项</h2>
      <p>切换域名后，如果遇到登录状态丢失的情况，只需重新登录即可。所有账户信息和积分数据不会因域名切换而丢失。</p>
    `,
    category: 'fangwen-jiaocheng',
    categoryName: '访问教程',
    date: '2026-08-05',
    readTime: 4,
  },
  {
    slug: 'shouji-duan-caoliu-fangwen-zhinan',
    title: '手机端草榴社区访问完整指南',
    excerpt: '针对移动端用户，详细介绍如何在手机上流畅访问草榴社区，包括浏览器推荐与设置优化。',
    content: `
      <p>越来越多的用户选择使用手机访问草榴社区。本文将详细介绍手机端访问的最佳实践，帮助您获得流畅的移动浏览体验。</p>
      <h2>推荐浏览器</h2>
      <p>手机端建议使用Chrome移动版或Safari浏览器，这些浏览器对网页兼容性最佳。部分内置浏览器可能存在兼容性问题，建议更换为标准浏览器访问。</p>
      <h2>网络设置优化</h2>
      <p>如果遇到访问缓慢的情况，可以尝试切换Wi-Fi与移动数据网络，或开启飞行模式后重新连接。部分地区可能需要使用特定DNS设置以获得更好的访问速度。</p>
      <h2>移动端特有功能</h2>
      <p>草榴社区的移动端适配良好，支持触屏操作和手势浏览。您可以像使用桌面版一样浏览帖子、发表回复和查看消息。</p>
    `,
    category: 'fangwen-jiaocheng',
    categoryName: '访问教程',
    date: '2026-08-04',
    readTime: 5,
  },
  {
    slug: 'caoliu-dizhi-shibian-fangfa',
    title: '草榴地址失效怎么办？五种方法快速找回入口',
    excerpt: '当草榴社区地址失效时不要慌张，本文教你五种可靠方法快速找回最新入口地址。',
    content: `
      <p>地址失效是每位草榴社区用户都可能遇到的问题。当发现无法访问时，保持冷静，按照以下方法操作即可快速找回入口。</p>
      <h2>方法一：查看本导航站</h2>
      <p>将本导航站加入浏览器书签，这是最便捷的方式。我们会在第一时间更新最新可用地址。</p>
      <h2>方法二：清除DNS缓存</h2>
      <p>有时地址失效是因为本地DNS缓存导致的。在命令提示符中运行 ipconfig /flushdns 清除DNS缓存后再试。</p>
      <h2>方法三：更换DNS服务器</h2>
      <p>尝试将DNS服务器更换为公共DNS如 8.8.8.8 或 1.1.1.1，有时可以解决访问问题。</p>
      <h2>方法四：使用代理或VPN</h2>
      <p>在某些网络环境下，可能需要借助代理服务或VPN来访问。请选择信誉良好的服务商。</p>
      <h2>方法五：等待自动恢复</h2>
      <p>如果以上方法都无效，可能是服务器端正在进行维护。通常维护时间不会超过24小时。</p>
    `,
    category: 'changjian-wenti',
    categoryName: '常见问题',
    date: '2026-08-03',
    readTime: 6,
  },
  {
    slug: 'caoliu-xinren-shangshou-zhinan',
    title: '草榴社区新人上手完全指南',
    excerpt: '面向新用户的详细入门指南，从注册到发帖，全面了解草榴社区的基本操作和规则。',
    content: `
      <p>欢迎来到草榴社区！如果你是新用户，这篇指南将帮助你快速了解社区的基本操作和规则。</p>
      <h2>注册与登录</h2>
      <p>草榴社区采用邀请制注册，新用户需要通过已有会员的邀请链接完成注册。注册时请使用真实邮箱地址，以便接收重要通知。</p>
      <h2>社区版块介绍</h2>
      <p>草榴社区设有多个版块，涵盖技术讨论、生活分享、影视娱乐等多个领域。建议先浏览各版块的置顶帖了解版规。</p>
      <h2>发帖与回帖</h2>
      <p>发帖前请确认内容符合对应版块的规则。回帖时请尊重其他用户，保持友善交流。严禁发布违规内容和广告信息。</p>
      <h2>积分与等级</h2>
      <p>社区设有积分和等级系统，通过活跃参与可以获得积分并提升等级，解锁更多功能权限。</p>
    `,
    category: 'shiyong-jiqiao',
    categoryName: '使用技巧',
    date: '2026-08-02',
    readTime: 7,
  },
  {
    slug: 'caoliu-shequ-jifen-gonglue',
    title: '草榴社区积分获取全攻略：快速升级秘籍',
    excerpt: '详细解析草榴社区积分体系，分享高效获取积分的实用方法，助你快速提升等级。',
    content: `
      <p>积分是草榴社区的重要资源，高等级用户可以享受更多功能。本文将全面解析积分获取方式。</p>
      <h2>日常签到</h2>
      <p>每日签到是最基础的积分获取方式，连续签到还能获得额外奖励。养成每日签到的习惯是积分增长的基础。</p>
      <h2>发帖与回帖</h2>
      <p>发布高质量帖子可以获得大量积分奖励，特别是被加精或置顶的帖子。积极回帖也能稳定获取积分。</p>
      <h2>参与社区活动</h2>
      <p>社区不定期举办各类活动，参与活动通常可以获得丰厚的积分奖励。请关注公告版块了解最新活动信息。</p>
      <h2>资源分享</h2>
      <p>分享优质资源是获取积分最快的方式之一。用户对你的分享进行评分和感谢都会为你带来积分。</p>
    `,
    category: 'shiyong-jiqiao',
    categoryName: '使用技巧',
    date: '2026-08-01',
    readTime: 5,
  },
  {
    slug: 'caoliu-anquan-fangwen-xuzhi',
    title: '草榴社区安全访问须知与隐私保护建议',
    excerpt: '关注访问安全与隐私保护，了解如何在使用草榴社区时保护个人信息安全。',
    content: `
      <p>网络安全是每位用户都应重视的问题。本文提供草榴社区访问过程中的安全建议和隐私保护措施。</p>
      <h2>使用HTTPS连接</h2>
      <p>始终确保访问地址以https开头，加密连接可以有效防止中间人攻击。如果发现地址栏显示不安全警告，请立即停止访问。</p>
      <h2>账户安全</h2>
      <p>设置强密码并定期更换，不要与其他网站使用相同密码。开启二次验证可以大幅提升账户安全性。</p>
      <h2>隐私保护</h2>
      <p>在社区中避免透露个人真实信息，包括真实姓名、地址、电话号码等。使用独立邮箱注册社区账号。</p>
      <h2>防范钓鱼网站</h2>
      <p>仅通过本导航站提供的地址访问社区，不要点击来源不明的链接。钓鱼网站通常会模仿社区界面骗取账号密码。</p>
    `,
    category: 'changjian-wenti',
    categoryName: '常见问题',
    date: '2026-07-30',
    readTime: 4,
  },
  {
    slug: 'caoliu-shequ-2026-banjiu-gengxin',
    title: '草榴社区2026年版本更新内容一览',
    excerpt: '汇总草榴社区2026年以来的各项功能更新与界面优化，了解最新变化。',
    content: `
      <p>2026年草榴社区进行了多项功能和界面优化，旨在提升用户体验。以下是主要更新内容汇总。</p>
      <h2>界面优化</h2>
      <p>社区首页进行了重新设计，布局更加清晰，导航更加便捷。移动端适配也得到了大幅改善。</p>
      <h2>搜索功能增强</h2>
      <p>全新的搜索引擎支持更精准的内容检索，可以根据时间、版块、作者等多个维度筛选结果。</p>
      <h2>消息系统升级</h2>
      <p>私信功能得到了全面升级，支持表情回复和文件传输，消息通知也更加及时。</p>
      <h2>性能提升</h2>
      <p>服务器基础设施升级后，页面加载速度和并发处理能力均有显著提升，高峰时段访问也更加流畅。</p>
    `,
    category: 'shequ-dongtai',
    categoryName: '社区动态',
    date: '2026-07-28',
    readTime: 3,
  },
];

export const faqs = [
  {
    question: '如何找到草榴社区最新可用地址？',
    answer: '您可以通过将本导航站加入浏览器书签来随时获取最新地址。我们会在地址更新后第一时间在本站发布公告。同时建议关注社区官方社交媒体账号，获取即时更新通知。也可以定期清除浏览器缓存和DNS缓存，尝试使用备用域名访问。',
  },
  {
    question: '为什么有些地址无法访问？',
    answer: '地址无法访问通常有以下几种原因：一是DNS解析问题，可以尝试清除DNS缓存或更换DNS服务器；二是网络运营商的限制，可以尝试切换网络环境或使用代理；三是服务器端可能正在进行临时维护，通常在几小时内恢复。如果长时间无法访问，请查看本导航站获取最新地址。',
  },
  {
    question: '推荐使用什么浏览器访问草榴社区？',
    answer: '推荐使用Chrome、Firefox或Edge等主流浏览器的最新版本。这些浏览器对网页标准的支持最为完善，能够提供最佳的浏览体验和安全性。建议保持浏览器自动更新开启，以获得最新的安全补丁。移动端推荐使用Chrome移动版或Safari。',
  },
  {
    question: '手机端如何访问草榴社区？',
    answer: '手机端访问与桌面端一致，使用浏览器打开本导航站提供的地址即可。社区网站已针对移动端做了响应式适配，在手机上也能获得良好的浏览体验。建议在Wi-Fi环境下访问以获得更快的加载速度。如遇到显示异常，可以尝试切换至桌面版视图。',
  },
  {
    question: '地址失效了怎么办？',
    answer: '首先确认是否为网络问题，可以尝试刷新页面、清除浏览器缓存、切换网络（Wi-Fi/移动数据）等操作。然后检查本导航站是否已发布最新地址公告。如果这些方法都无效，请等待一段时间后再试，服务器可能正在进行临时维护。建议提前收藏多个备用域名以防万一。',
  },
  {
    question: '如何辨别真假草榴社区网站？',
    answer: '请仅通过本官方导航站提供的地址访问草榴社区。真正的草榴社区不会通过弹窗要求下载任何软件，也不会要求提供银行卡信息或支付密码。访问时请注意核对网址拼写，仿冒网站往往在域名上有细微差别。如发现可疑网站，请勿输入任何账户信息。',
  },
  {
    question: '草榴社区是否需要付费？',
    answer: '草榴社区的基础功能对所有注册用户免费开放。社区通过会员捐赠和广告维持运营。如果遇到要求付费才能访问的情况，请确认是否进入了仿冒网站。官方社区不会以任何理由向用户索取费用。',
  },
  {
    question: '如何获取访问教程中提到的工具？',
    answer: '本导航站提供的访问教程均为通用技术方案，不涉及特定商业产品的推广。教程中提到的工具（如浏览器、DNS设置方法等）均为常见免费工具，您可以直接在设备上使用，无需额外下载或购买。',
  },
];

export const addressList = [
  {
    id: 1,
    type: 'primary',
    label: '主域名',
    status: 'normal',
    statusText: '正常',
  },
  {
    id: 2,
    type: 'backup',
    label: '备用域名 01',
    status: 'normal',
    statusText: '正常',
  },
  {
    id: 3,
    type: 'backup',
    label: '备用域名 02',
    status: 'normal',
    statusText: '正常',
  },
  {
    id: 4,
    type: 'backup',
    label: '备用域名 03',
    status: 'maintenance',
    statusText: '维护中',
  },
];